import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { SAMPLE_PROSPECTING_SAMPLE_REQUEST_COMPLETE_VALUE } from "@faire/retailer-visitor-shared/components/App/AppModals/consts";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { getSessionCountry } from "@faire/retailer-visitor-shared/serialized-data/getSessionCountry";
import { logError } from "@faire/web--source/common/logging";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { QueryParameters as PostSampleQueryParams } from "@faire/web-api--source/api/retailer/sample/prospected-sample-request/brand/brandToken/post";
import { useMutation as usePostSampleRequest } from "@faire/web-api--source/api/retailer/sample/prospected-sample-request/brand/brandToken/post-hooks";
import { trackSamplesGuestRetailerConfirmationModalView } from "@faire/web-api--source/events/samples/view/guestRetailerConfirmationModal";
import { trackSamplesShippingDetailsModalView } from "@faire/web-api--source/events/samples/view/shippingDetailsModal";
import { ISubmitProspectedSampleRequestFormRequest } from "@faire/web-api--source/faire/samples/ISubmitProspectedSampleRequestFormRequest";
import { IAddress } from "@faire/web-api--source/indigofair/data/IAddress";
import { IMatchedBusiness } from "@faire/web-api--source/indigofair/data/IMatchedBusiness";
import { QueryParameters as SignUpQueryParameters } from "@faire/web-api--source/routes/direct/brandAlias";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { ImageOrLogo } from "@faire/retailer/components/AppSignUp/components/ImageOrLogo";
import { GuestRetailerConfirmationModal } from "./GuestRetailerConfirmationModal";
import { ShippingDetails } from "./ShippingDetails";
var ModalState;
(function(ModalState) {
    ModalState[ModalState["SHIPPING_DETAILS"] = 0] = "SHIPPING_DETAILS";
    ModalState[ModalState["CONFIRMATION"] = 1] = "CONFIRMATION";
})(ModalState || (ModalState = {}));
export var ProspectingSampleSignupFlow = function(param) {
    var brand = param.brand, email = param.email;
    var sessionCountry = getSessionCountry();
    var _useState = _sliced_to_array(useState(ModalState.SHIPPING_DETAILS), 2), modalState = _useState[0], setModalState = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        email: email,
        firstName: "",
        lastName: "",
        phoneNumber: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipcode: "",
        storeName: "",
        country: sessionCountry !== null && sessionCountry !== void 0 ? sessionCountry : "",
        optIntoEmailNotifications: true,
        matchedBusiness: IMatchedBusiness.build()
    }), 2), formValues = _useState1[0], setFormValues = _useState1[1];
    var push = useHistory().push;
    var faireDirectBrandToken = useFaireDirectBrand().faireDirectBrandToken;
    var sampleInvite = useQueryParams(SignUpQueryParameters.parse).sampleInvite;
    var _usePostSampleRequest = usePostSampleRequest(), postSampleRequest = _usePostSampleRequest.mutate, isError = _usePostSampleRequest.isError, error = _usePostSampleRequest.error, isLoading = _usePostSampleRequest.isPending;
    useEffect(function() {
        setFormValues({
            email: email,
            firstName: "",
            lastName: "",
            phoneNumber: "",
            address1: "",
            address2: "",
            city: "",
            state: "",
            zipcode: "",
            storeName: "",
            country: sessionCountry !== null && sessionCountry !== void 0 ? sessionCountry : "",
            optIntoEmailNotifications: true,
            matchedBusiness: IMatchedBusiness.build()
        });
    }, [
        email,
        sessionCountry
    ]);
    var redirectToLandingPage = function() {
        push(getCurrentPath().delete("email").replace({
            signUp: SAMPLE_PROSPECTING_SAMPLE_REQUEST_COMPLETE_VALUE
        }).toString());
    };
    var trackSamplesShippingDetailsModalViewRef = useDoActionWhenVisible(function() {
        trackSamplesShippingDetailsModalView();
    });
    var trackSamplesGuestRetailerConfirmationModalViewRef = useDoActionWhenVisible(function() {
        trackSamplesGuestRetailerConfirmationModalView();
    });
    var _formValues_matchedBusiness_id;
    return /*#__PURE__*/ _jsxs(Container, {
        "data-test-id": "prospecting-sample-signup",
        children: [
            /*#__PURE__*/ _jsx(LogoXFaire, {
                children: /*#__PURE__*/ _jsx(ImageOrLogo, {
                    logo: true,
                    image: brand.profile_image
                })
            }),
            modalState === ModalState.SHIPPING_DETAILS ? /*#__PURE__*/ _jsx(FormWrapper, {
                ref: trackSamplesShippingDetailsModalViewRef,
                children: /*#__PURE__*/ _jsx(ShippingDetails, {
                    initialValues: formValues,
                    setFormValues: setFormValues,
                    onSubmit: function(values, param) {
                        var setSubmitting = param.setSubmitting;
                        return postSampleRequest([
                            faireDirectBrandToken,
                            ISubmitProspectedSampleRequestFormRequest.build({
                                email_address: values.email,
                                first_name: values.firstName,
                                last_name: values.lastName,
                                destination_address: IAddress.build({
                                    name: values.firstName + " " + values.lastName,
                                    address1: values.address1,
                                    address2: values.address2,
                                    city: values.city,
                                    state: values.state,
                                    postal_code: values.zipcode,
                                    country: values.country,
                                    phone_number: values.phoneNumber
                                }),
                                opt_into_email_notifications: values.optIntoEmailNotifications,
                                matched_business: values.matchedBusiness
                            }),
                            PostSampleQueryParams.build({
                                invite_token: sampleInvite
                            })
                        ], {
                            onSuccess: function() {
                                setModalState(ModalState.CONFIRMATION);
                                setSubmitting(false);
                            },
                            onError: function(error) {
                                logError(error);
                                setSubmitting(false);
                            }
                        });
                    },
                    apiCallFailed: isError,
                    apiCallIsLoading: isLoading,
                    apiCallError: error
                })
            }) : null,
            modalState === ModalState.CONFIRMATION ? /*#__PURE__*/ _jsx(GuestRetailerConfirmationModal, {
                bannerImage: brand.banner_image,
                name: "".concat(formValues.firstName, " ").concat(formValues.lastName),
                email: formValues.email,
                storeName: formValues.storeName,
                country: formValues.country,
                googlePlaceId: (_formValues_matchedBusiness_id = formValues.matchedBusiness.id) !== null && _formValues_matchedBusiness_id !== void 0 ? _formValues_matchedBusiness_id : "",
                phoneNumber: formValues.phoneNumber,
                onLearnMoreClick: redirectToLandingPage,
                ref: trackSamplesGuestRetailerConfirmationModalViewRef
            }) : null
        ]
    });
};
export var Container = styled(Column).attrs({
    justify: "center",
    align: "center",
    gap: "3x"
}).withConfig({
    componentId: "sc-50586385-0"
})([
    "background:",
    ";width:100%;padding:40px;height:auto;min-height:100vh;"
], Decorative.tint.neutral);
export var FormWrapper = styled(Column).attrs({
    gap: "3x",
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-50586385-1"
})([
    ""
]);
var LogoXFaire = styled(Row).attrs({
    justify: "center"
}).withConfig({
    componentId: "sc-50586385-2"
})([
    ""
]);
